import { createFileRoute, Navigate } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { LearnerReportPage } from "@/features/admin/learner-report/LearnerReportPage";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/admin/users_/$userId")({
  component: LearnerReportRoute,
  remountDeps: ({ params }) => params.userId,
});

/** One learner's course and learning path progress. */
function LearnerReportRoute() {
  const { userId } = Route.useParams();
  const { hasPermission } = usePermissions();

  return (
    // ProtectedRoute lets in anyone with ANY of the permissions OR the role. The report needs both
    // permissions, which can be taken off any role, so the page checks each of them again.
    <ProtectedRoute
      requiredPermissions={["Users.Read", "Analytics.Read"]}
      requiredRoles={["Admin"]}
    >
      {hasPermission("Users.Read") && hasPermission("Analytics.Read") ? (
        <AdminPageLayout mainClassName="bg-secondary_alt">
          <LearnerReportPage userId={userId} />
        </AdminPageLayout>
      ) : (
        <Navigate to="/admin" />
      )}
    </ProtectedRoute>
  );
}
